module.exports = __webpack_public_path__ + "static/media/leftArrowSelected.6c9efe0c.svg";